import { render } from "./Notice.vue?vue&type=template&id=40db6714&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"

import "./Notice.vue?vue&type=style&index=0&id=40db6714&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40db6714"]])

export default __exports__